import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { format } from 'date-fns';
import { formatDate } from 'utils/utils.js';
import constants from 'utils/constants';

export default function ChatItemList({chatList, scrollRef, onScroll}) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });

  return (
    <ListSection ref={scrollRef} onScroll={(e)=>{if(onScroll)onScroll(e);}} key={`chat-item-list-section`}>
    {
      chatList.map((value, index)=>{
        let chatDom = [];
        let dateSplitter = [];
        let currItemDate = formatDate(value['create_date']);
        let formattedDate = format(new Date(value['create_date']), 'yyyy.MM.dd');
        if(index === 0)
        {
          dateSplitter.push(<LineSplitter key={`chatting-date-splitter-${currItemDate}`}><SplitterDate>{formattedDate}</SplitterDate></LineSplitter>);
        }
        else if(formatDate(chatList[index-1]['create_date']) !== currItemDate)
        {
          dateSplitter.push(<LineSplitter key={`chatting-date-splitter-${currItemDate}`}><SplitterDate>{formattedDate}</SplitterDate></LineSplitter>);
        }

        //ChatDom  
        if(parseInt(userInfo['id']) === parseInt(value['user_no']))
        {
          //rightChat
          if((index === 0) || chatList[index - 1]['user_no'] !== value['user_no'])
          {
            chatDom.push(
              <ChatWrapper key={`chat-item-${value['no']}`}>
                <RightChat>
                <MyChatItem>{value['content']}</MyChatItem>
                </RightChat>
              </ChatWrapper>
            );
          }
          else
          {
            chatDom.push(
              <ChatWrapper key={`chat-item-${value['no']}`}>
                <RightChat>
                <MyContChatItem>{value['content']}</MyContChatItem>
                </RightChat>
              </ChatWrapper>
            );
          }
        }
        else
        {
          //leftchat
          if((dateSplitter.length > 0) || (index === 0) || chatList[index - 1]['user_no'] !== value['user_no']) 
          {
            let profileImgSrc = `${constants['imagePath']}/user_profile_img/${value['profile_img']}`;
            chatDom.push(
              <ChatWrapper key={`chat-item-${value['no']}`}>
                <LeftChat>
                  <ProfileWrapper>
                    <ProfileImgWrapper key={`chat-profile-img-no-${value['no']}`}>
                      <ProfileImg src={profileImgSrc} />
                    </ProfileImgWrapper>
                    <ProfileInfoWrapper>
                      <ProfileNickname>{value['nickname']}</ProfileNickname>
                      <FriendChatItem>{value['content']}</FriendChatItem>
                    </ProfileInfoWrapper>
                  </ProfileWrapper>
                </LeftChat>
              </ChatWrapper>
            );
          }
          else
          {
            chatDom.push(
              <ChatWrapper key={`chat-item-${value['no']}`}>
                <LeftChat>
                  <FriendContChatItem>{value['content']}</FriendContChatItem>
                </LeftChat>
              </ChatWrapper>
            );
          }

          
        }

        return (<div key={`chat-item-wrapper-${value['no']}`}>
          {dateSplitter}
          {chatDom}
        </div>);
      })
    }
    </ListSection>
  );
}
const LineSplitter = styled.div`
  text-align:center;
  position:relative;
  &::after{
    content: '';
    width: 100%;
    height: 1px;
    background-color: #D0D0D0;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    padding: 0 calc(100vw*(17/375));
    background-clip: content-box;
    box-sizing: border-box;
  }
`;
const SplitterDate = styled.span`
  position: relative;
  display: inline-block;
  background: #f7f7f7;
  padding: 0 calc(100vw*(36/375));
  z-index: 100;
  color:#D0D0D0;
`;
const ListSection  = styled.div`
  height: 100%;
  overflow-y: scroll;
  padding: 0 calc(100vw*(17/375));
`;
const ChatWrapper = styled.div`
  &:after{
    display: block;
    content: " ";
    clear : both;
  }
`;
const LeftChat = styled.div`
  float: left;
  max-width: 60%;
`;
const RightChat = styled.div`
  float: right;
  max-width: 60%;
`;
const ProfileWrapper = styled.div`
  &::after{
    display: block;
    content: " ";
    clear: both;
  }
`;
const ProfileImgWrapper = styled.div`
  width : calc(100vw*(40/375));
  height: calc(100vw*(40/375));
  border-radius: 100%;
  overflow: hidden;
  float: left;
  margin-right:calc(100vw*(8/375));
`
const ProfileImg = styled.img`
  width : 100%;
  height: 100%;
  object-fit: cover;
`;
const ProfileNickname = styled.div`
display: inline-block;
margin-bottom:calc(100vw*(2/375));
`;

const ProfileInfoWrapper = styled.div`
float: left;
`;

//MyChatItem

//ChatItem
const ChatItem = styled.div`
  font-weight: normal;
  font-size: calc(100vw*(14/375));
  line-height: calc(100vw*(20/375));
  color: #121212;
  padding : calc(100vw*(7/375)) calc(100vw*(12/375));
  background: white;
  border-radius: calc(100vw*(17/375));
  margin-bottom : calc(100vw*(6/375));
  white-space: pre-wrap;
  text-align: left;
`;
const FriendChatItem = styled(ChatItem)`
border-top-left-radius: 0;
`;

const FriendContChatItem = styled(ChatItem)`
  margin-left: calc(100vw*(48/375));
`;
const MyChatItem = styled(ChatItem)`
  border-top-right-radius: 0;
  background:#FFEFCE;
`;
const MyContChatItem = styled(ChatItem)`
  background:#FFEFCE;
`